module.exports = __webpack_public_path__ + "img/PEN.d8d02706.svg";